import { ContactForm } from "./ContactForm";
import { SocialLinks } from "./SocialLinks";
import { SuccessMessage } from "./SuccessMessage";

const ContactComponents = { ContactForm, SocialLinks, SuccessMessage };

export default ContactComponents;
